import React from "react";
import Layout from "../layout/Layout";
import TransitJourneyTemplate from "../templates/transit-journey-template/Main";
import { internationalToDomestic } from "../utils/keywords";
import { useSeoData } from "../templates/seo/Main";

const InternationalToDomesticPage = ({ pageContext }) => {
  const {
    breadcrumb: { crumbs },
  } = pageContext;
  return (
    <Layout crumbs={crumbs} crumbLabel={"International to Domestic"}>
      <TransitJourneyTemplate keyword={internationalToDomestic} />
    </Layout>
  );
};

export default InternationalToDomesticPage;

// Seo meta details
export const Head = () => {
  const { meta_title, meta_description, meta_keyword } = useSeoData("international-to-domestic");

  return (
    <>
      <title>{meta_title}</title>
      <meta
        name="description"
        content={meta_description?.data?.meta_description}
      />
      <meta name="keywords" content={meta_keyword?.data?.meta_keyword} />
    </>
  );
};
